import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { waitForAuthUser } from '../utils/wait-for-auth';

export const guestGuard: CanActivateFn = async (): Promise<boolean> => {
  const auth = inject(Auth);
  const router = inject(Router);
  const user = await waitForAuthUser(auth);
  if (!user) {
    return true;
  }
  await router.navigate(['/home'], { replaceUrl: true });
  return false;
};
